module.exports = __webpack_public_path__ + "img/xls.5d9035be.png";